import { css } from '@emotion/react';
import { HitType } from '@types';
import { Loader } from '@components/utils';

import Header from './Header';
import ContributionTable from './ContributionTable';

export type ContributionPropsType = {
  hitsAchievement: HitType[]
  isLoading?: boolean
};

const Contribution = ({ hitsAchievement, isLoading }: ContributionPropsType) => {
  return (
    <>
      <Header projectName={hitsAchievement[0]?.projectName} />
      <div
        css={css`
          margin-top: 16px;
        `}
      >
        {isLoading && <Loader />}
        {!isLoading && <ContributionTable hitsAchievement={hitsAchievement} />}
      </div>
    </>
  );
};

export default Contribution;
